import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";
import { Ship, Menu, X } from "lucide-react";
import { useState } from "react";

interface NavbarProps {
  onQuoteClick?: () => void;
}

export const Navbar = ({ onQuoteClick }: NavbarProps = {}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-white/10 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <NavLink to="/" className="flex items-center space-x-2.5 group">
            <div className="flex items-center gap-2.5">
              <div className="bg-primary/10 p-2 rounded-xl group-hover:bg-primary/20 transition-colors duration-300">
                <Ship className="h-6 w-6 text-primary group-hover:rotate-3 transition-transform duration-300" />
              </div>
              <span className="font-extrabold text-xl md:text-2xl tracking-wider bg-clip-text text-transparent bg-gradient-to-r from-primary to-blue-600 font-sans">
                COSTAL <span className="text-foreground font-semibold">MERIDIAN</span>
              </span>
            </div>
          </NavLink>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink
              to="/"
              className="text-foreground hover:text-primary transition-colors font-bold text-sm tracking-wide"
              activeClassName="text-primary font-bold"
            >
              Home
            </NavLink>
            <NavLink
              to="/services"
              className="text-foreground hover:text-primary transition-colors font-bold text-sm tracking-wide"
              activeClassName="text-primary font-bold"
            >
              Services
            </NavLink>
            <NavLink
              to="/about"
              className="text-foreground hover:text-primary transition-colors font-bold text-sm tracking-wide"
              activeClassName="text-primary font-bold"
            >
              About
            </NavLink>
            <NavLink
              to="/contact"
              className="text-foreground hover:text-primary transition-colors font-bold text-sm tracking-wide"
              activeClassName="text-primary font-bold"
            >
              Contact
            </NavLink>
            <Button variant="secondary" size="sm" asChild className="hover-scale">
              <NavLink to="/tracking">Track</NavLink>
            </Button>
            <Button variant="default" size="sm" onClick={onQuoteClick} className="hover-scale">
              Get Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-4">
            <NavLink
              to="/"
              className="block py-2 text-foreground hover:text-primary transition-colors"
              onClick={() => setIsOpen(false)}
            >
              Home
            </NavLink>
            <NavLink
              to="/services"
              className="block py-2 text-foreground hover:text-primary transition-colors"
              onClick={() => setIsOpen(false)}
            >
              Services
            </NavLink>
            <NavLink
              to="/about"
              className="block py-2 text-foreground hover:text-primary transition-colors"
              onClick={() => setIsOpen(false)}
            >
              About
            </NavLink>
            <NavLink
              to="/contact"
              className="block py-2 text-foreground hover:text-primary transition-colors"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </NavLink>
            <div className="flex gap-2 pt-2">
              <Button variant="secondary" size="sm" asChild className="flex-1 hover-scale" onClick={() => setIsOpen(false)}>
                <NavLink to="/tracking">Track</NavLink>
              </Button>
              <Button variant="default" size="sm" className="flex-1 hover-scale" onClick={() => { onQuoteClick?.(); setIsOpen(false); }}>
                Get Quote
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
